<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" v-if="bread.length>0">
      <el-breadcrumb-item v-for="(item,index) in bread" :key="index" :class="item.class" @click.native="breadLink(item)">{{ item.title }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default{
  props:{
    bread:{
      type:Array,
      default:[]
    }
  },
  data(){
    return{

    }
  },
  methods: {
    breadLink(item){
      console.log(item,'item')
      //统一跳转
      if(!item.url) return;
      this.$router.push({
        name:item.url.name,
        params:item.url.params
        // query:item.url.query
      })
      //自定义跳转
      // this.$emit('handleBreadClick',item)
    }
  },
}
</script>
<style lang="scss" scoped>
:deep(.breadFirst){
  .el-breadcrumb__inner{
     color: #98a3b7;
     cursor: pointer;
  }
}
:deep(.breadLast){
  .el-breadcrumb__inner{
    color: #333333;
  }
}
:deep(.bread){
  .el-breadcrumb__inner{
    color: #98a3b7;
    
  }
}
</style>